import { IPatternWithNoPatternBusinessLogic } from '@vfde-brix/ws10/core';
import {
    createImage,
    IImageProperties,
    Image,
} from '@vfde-brix/ws10/image';

/**
 * Mount Image
 */
export default function mountImage (
    id: string,
    properties: IImageProperties | IPatternWithNoPatternBusinessLogic,
    dom = document,
): Image | null {
    const container = dom.getElementById(id);

    return container && createImage(container, properties);
}
